import type {
	HelpPointCategory,
	HelpPointLinkModel,
	HelpPointPlaylist,
	HelpPointPlaylistItem,
	HelpPointVideo
} from "../model";
import {
	FETCH_HELP_POINT_CATEGORIES,
	FETCH_HELP_POINT_LINK_BY_IDENTIFIER,
	FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID,
	FETCH_HELP_POINT_VIDEO_DETAILS,
	FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS
} from "../action";

export type HelpPointState = {
	categories: HelpPointCategory[],
	newestPlaylistItems: HelpPointPlaylistItem[],
	isFetchingCategories: boolean,
	isFetchingNewestPlaylistItems: boolean,
	isFetchingVideoDetails: boolean,
	isFetchingVideoPlaylist: boolean,
	selectedVideo: HelpPointVideo,
	selectedVideoPlaylist: HelpPointPlaylist,
	isFetchingHelpPointLink: boolean,
	helpPointLinks: HelpPointLinkModel[]
}

const initialState: HelpPointState = {
	categories: [],
	newestPlaylistItems: [],
	isFetchingCategories: false,
	isFetchingNewestPlaylistItems: false,
	isFetchingVideoDetails: false,
	isFetchingVideoPlaylist: false,
	selectedVideo: null,
	selectedVideoPlaylist: [],
	isFetchingHelpPointLink: false,
	helpPointLinks: []
};

const helpPoint = (state: HelpPointState = initialState, action: any) => {
	switch (action.type) {
		case FETCH_HELP_POINT_CATEGORIES.REQUEST:
			return {
				...state,
				isFetchingCategories: true
			};
		case FETCH_HELP_POINT_CATEGORIES.SUCCESS:
			return {
				...state,
				categories: action.payload,
				isFetchingCategories: false
			};
		case FETCH_HELP_POINT_CATEGORIES.FAILURE:
			return {
				...state,
				isFetchingCategories: false
			};
		case FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.REQUEST:
			return {
				...state,
				isFetchingNewestPlaylistItems: true
			};
		case FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.SUCCESS:
			return {
				...state,
				newestPlaylistItems: action.payload,
				isFetchingNewestPlaylistItems: false
			};
		case FETCH_NEWEST_HELP_POINT_PLAYLIST_ITEMS.FAILURE:
			return {
				...state,
				isFetchingNewestPlaylistItems: false
			};
		case FETCH_HELP_POINT_VIDEO_DETAILS.REQUEST:
			return {
				...state,
				isFetchingVideoDetails: true
			};
		case FETCH_HELP_POINT_VIDEO_DETAILS.SUCCESS:
			return {
				...state,
				selectedVideo: action.payload,
				isFetchingVideoDetails: false
			};
		case FETCH_HELP_POINT_VIDEO_DETAILS.FAILURE:
			return {
				...state,
				isFetchingVideoDetails: false
			};
		case FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.REQUEST:
			return {
				...state,
				isFetchingVideoPlaylist: true
			};
		case FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.SUCCESS:
			return {
				...state,
				selectedVideoPlaylist: action.payload,
				isFetchingVideoPlaylist: false
			};
		case FETCH_HELP_POINT_PLAYLIST_BY_VIDEO_ID.FAILURE:
			return {
				...state,
				isFetchingVideoPlaylist: false
			};
		case FETCH_HELP_POINT_LINK_BY_IDENTIFIER.REQUEST:
			return {
				...state,
				isFetchingHelpPointLink: true
			};
		case FETCH_HELP_POINT_LINK_BY_IDENTIFIER.SUCCESS:
			const incomingLink = action.payload;

			const updatedLinks = [...state.helpPointLinks.filter(
				item => item.id !== incomingLink.id
			)];

			return {
				...state,
				helpPointLinks: [...updatedLinks, incomingLink],
				isFetchingHelpPointLink: false
			};
		case FETCH_HELP_POINT_LINK_BY_IDENTIFIER.FAILURE:
			return {
				...state,
				isFetchingHelpPointLink: false
			};
		default:
			return state;
	}
};

export default helpPoint;